module.exports = __webpack_public_path__ + "assets/img/store-banner-05.7e11592b.png";